/* BioLux home: goal chips, search dock and the guided protocol flow. No dependencies. */
(function () {
  'use strict';
  if (window.__bxLoaded) return;
  window.__bxLoaded = true;

  /* A page change that cannot animate is skipped by the browser. That is not an error worth reporting. */
  ['pageswap', 'pagereveal'].forEach(function (name) {
    window.addEventListener(name, function (e) {
      var t = e.viewTransition;
      if (!t) return;
      [t.ready, t.finished, t.updateCallbackDone].forEach(function (p) { if (p && p.catch) p.catch(function () {}); });
    });
  });

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ---------- tiny DOM builder: text always goes in as text, never as markup ---------- */
  function h(tag, attrs) {
    var el = document.createElement(tag);
    for (var k in attrs || {}) {
      var v = attrs[k];
      if (v == null || v === false) continue;
      if (k === 'class') el.className = v;
      else if (k === 'text') el.textContent = v;
      else if (k === 'svg') el.innerHTML = v;
      else if (k.slice(0, 2) === 'on') el.addEventListener(k.slice(2), v);
      else el.setAttribute(k, v === true ? '' : v);
    }
    for (var i = 2; i < arguments.length; i++) {
      var c = arguments[i];
      if (c == null || c === false) continue;
      el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    }
    return el;
  }
  function svg(paths, size) {
    return '<svg width="' + (size || 20) + '" height="' + (size || 20) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + paths + '</svg>';
  }
  var WA_ICON = '<svg width="20" height="20" viewBox="0 0 32 32" aria-hidden="true"><path fill="currentColor" d="M16 2.7C8.7 2.7 2.8 8.6 2.8 15.9c0 2.3.6 4.6 1.8 6.6L2.7 29.3l7-1.8c1.9 1 4.1 1.6 6.3 1.6 7.3 0 13.2-5.9 13.2-13.2S23.3 2.7 16 2.7zm0 24.2c-2 0-3.9-.5-5.6-1.5l-.4-.2-4.1 1.1 1.1-4-.3-.4a11 11 0 0 1-1.7-5.9C5 9.8 9.9 4.9 16 4.9s11 4.9 11 11-4.9 11-11 11zm6-8.2c-.3-.2-2-1-2.3-1.1-.3-.1-.5-.2-.7.2-.2.3-.8 1.1-1 1.3-.2.2-.4.2-.7.1-.3-.2-1.4-.5-2.6-1.6-1-.9-1.6-1.9-1.8-2.2-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.3.3-.6.1-.2 0-.4 0-.6l-1-2.5c-.3-.7-.6-.6-.8-.6h-.7c-.2 0-.6.1-.9.4-.3.3-1.2 1.1-1.2 2.8s1.2 3.2 1.4 3.5c.2.2 2.4 3.7 5.9 5.2.8.4 1.5.6 2 .7.8.3 1.6.2 2.2.1.7-.1 2-.8 2.3-1.6.3-.8.3-1.5.2-1.6-.1-.2-.3-.3-.6-.4z"/></svg>';
  var ICON = {
    weight: '<rect x="4" y="4" width="16" height="16" rx="3"/><path d="M8.5 9.2a5 5 0 0 1 7 0L13.6 12h-3.2L8.5 9.2Z"/>',
    menopause: '<circle cx="12" cy="12" r="8"/><path d="M12 4a4 4 0 0 1 0 8 4 4 0 0 0 0 8"/>',
    injury: '<rect x="2.5" y="8.5" width="19" height="7" rx="3.5" transform="rotate(-45 12 12)"/><path d="M10.6 10.6h.01M13.4 10.6h.01M10.6 13.4h.01M13.4 13.4h.01"/>',
    energy: '<path d="M13 2.5 5 13.5h6l-1 8 9-12h-6l0-7Z"/>',
    skin: '<path d="M11 3.5l1.9 5.1 5.1 1.9-5.1 1.9L11 17.5l-1.9-5.1L4 10.5l5.1-1.9L11 3.5Z"/><path d="M18.5 15.5v5M16 18h5"/>',
    muscle: '<path d="M6.5 6.5v11M3.5 9v6M17.5 6.5v11M20.5 9v6M6.5 12h11"/>',
    sleep: '<path d="M20 14.5A8 8 0 0 1 9.5 4 8 8 0 1 0 20 14.5Z"/>',
    gut: '<path d="M5 19c0-8 5-13 14-14 0 9-4 14-12 14H5Z"/><path d="M5 19c3-5 6-8 10-10"/>',
    immunity: '<path d="M12 3l7 3v5c0 4.5-3 8.2-7 10-4-1.8-7-5.5-7-10V6l7-3Z"/><path d="M9 12l2 2 4-4.5"/>',
    longevity: '<path d="M7.5 15.5a3.5 3.5 0 1 1 0-7c3 0 6 7 9 7a3.5 3.5 0 1 0 0-7c-3 0-6 7-9 7Z"/>',
    search: '<circle cx="11" cy="11" r="7"/><path d="M20 20l-3.6-3.6"/>',
    spark: '<path d="M12 3l2.2 6.3L20.5 11.5l-6.3 2.2L12 20l-2.2-6.3L3.5 11.5l6.3-2.2L12 3Z"/>',
    check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
    chat: '<path d="M4 5h16v11H9l-5 4V5Z"/>',
    guide: '<path d="M5 4h11a3 3 0 0 1 3 3v13H8a3 3 0 0 1-3-3V4Z"/><path d="M9 9h6M9 13h6"/>',
    arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>'
  };

  /* ---------- content: goals, the follow-up question for each, and what each answer points to ---------- */
  var GOALS = [
    { key: 'weight', tile: 'Weight', label: 'Weight and metabolism', short: 'stubborn weight', sub: 'Cravings, plateaus, slow metabolism', kw: 'weight loss lose fat slim slimming glp-1 glp1 appetite cravings hunger metabolism plateau belly tummy overweight diet',
      collection: '/collections/stubborn-weight-metabolic-slowdown', q: 'Which sounds more like you?',
      options: [
        { label: 'Appetite and cravings run the show', sub: 'Food noise, snacking, portions that creep', primary: 'tirzepatide', alt: 'semaglutide', why: 'Designed for appetite and blood sugar control when willpower alone is not cutting it.' },
        { label: 'I eat well but my metabolism feels asleep', sub: 'Doing the right things, scale will not move', primary: 'mots-c', alt: 'nad', why: 'Works at the cellular energy level to support a metabolism that has gone quiet.' }
      ] },
    { key: 'menopause', tile: 'Menopause', label: 'Menopause', short: 'menopause support', sub: 'Weight, sleep, skin and energy shifting', kw: 'menopause perimenopause hormones hormonal hot flushes flashes midlife women night sweats mood',
      collection: '/collections/menopause-support', q: 'What has changed the most?',
      options: [
        { label: 'Weight settling on tummy and hips', sub: 'Cravings and stubborn midsection fat despite effort', primary: 'tirzepatide', alt: 'semaglutide', why: 'Calms appetite and supports blood sugar control when weight loss has stopped being a discipline problem.' },
        { label: 'Sleep, recovery and muscle tone slipping', sub: 'You sleep, but never wake up restored', primary: 'cjc-1295-ipamorelin-combo', alt: 'ipamorelin', why: 'Supports your natural growth hormone rhythm for deeper sleep, better recovery and a leaner composition.' },
        { label: 'Flat, foggy and running on empty', sub: 'Low energy that sleep alone does not fix', primary: 'nad', alt: 'mots-c', why: 'Rebuilds the cellular energy behind the fatigue, brain fog and dulled vitality menopause brings.' },
        { label: 'Skin and hair aging faster than you feel', sub: 'Thinner, drier skin and flatter hair', primary: 'ghk-cu', alt: 'nad', why: 'The copper peptide for collagen, skin firmness and healthier hair as collagen declines.' },
        { label: 'Bloated, achy and slow to settle', sub: 'A gut and body that suddenly feel reactive', primary: 'bpc-157', alt: 'nad', why: 'Gut lining and tissue repair support when menopause shows up as inflammation and puffiness.' },
        { label: 'Metabolism stuck in the wrong gear', sub: 'Doing everything right, body not responding', primary: 'mots-c', alt: 'tirzepatide', why: 'Works at the mitochondrial level to restore insulin sensitivity and metabolic resilience.' }
      ] },
    { key: 'injury', tile: 'Injury and pain', label: 'Injury and chronic pain', short: 'an injury that will not heal', sub: 'The same spot keeps flaring', kw: 'injury injured pain painful tendon ligament joint knee shoulder back elbow hip sprain strain heal healing repair inflammation arthritis',
      collection: '/collections/injury-that-won-t-heal-chronic-pain', q: 'What best describes it?',
      options: [
        { label: 'One stubborn tendon, ligament or joint', sub: 'The same spot flares every time you load it', primary: 'bpc-157', alt: 'bpc-157-tb-500-combo', why: 'Targeted repair support for the soft tissue structures that keep letting you down.' },
        { label: 'Widespread stiffness and old injuries', sub: 'Multiple areas, restricted movement', primary: 'tb-500', alt: 'bpc-157-tb-500-combo', why: 'Systemic repair support chosen when recovery feels incomplete across the board.' }
      ] },
    { key: 'energy', tile: 'Energy and focus', label: 'Energy and focus', short: 'burnout and brain fog', sub: 'Burnout, fatigue, brain fog', kw: 'energy burnout fatigue tired tiredness exhausted exhaustion brain fog focus concentration stress stressed motivation',
      collection: '/collections/burnout-fatigue-brain-fog', q: 'Which hits closer to home?',
      options: [
        { label: 'Flat energy, hard to get going', sub: 'Mornings are a grind, afternoons crash', primary: 'nad', alt: 'ss31', why: 'Supports the cellular energy currency your body runs on, chosen first for deep fatigue.' },
        { label: 'Wired but tired and run down', sub: 'Stressed, foggy, never quite recovered', primary: 'glutathione', alt: 'thymosin-alpha-1', why: 'The master antioxidant, chosen when stress load and burnout leave you depleted.' }
      ] },
    { key: 'skin', tile: 'Skin and hair', label: 'Skin, hair and glow', short: 'skin, hair and glow', sub: 'Looking tired or aged', kw: 'skin hair glow collagen wrinkles lines aging ageing anti-aging beauty firmness thinning hairloss complexion',
      collection: '/collections/skin-hair-glow-looking-tired-or-aged', q: 'What is your main focus?',
      options: [
        { label: 'Skin quality: lines, firmness, slow healing', sub: 'Skin feels thinner and duller than it should', primary: 'ghk-cu', alt: 'glutathione', why: 'The copper peptide known for skin remodelling, firmness and repair.' },
        { label: 'The deeper picture: looking tired overall', sub: 'People keep asking if you slept', primary: 'nad', alt: 'ghk-cu', why: 'Cellular energy support that shows up in how rested and fresh you look.' }
      ] },
    { key: 'muscle', tile: 'Muscle', label: 'Building muscle', short: 'building muscle', sub: 'Eating and training, staying small', kw: 'muscle gain build bulk strength gym hard gainer lean mass training bodybuilding performance',
      collection: '/collections/hard-gainer-struggling-to-build-muscle', q: 'What is holding you back most?',
      options: [
        { label: 'Growth is painfully slow', sub: 'Years of training, little to show', primary: 'ipamorelin', alt: 'cjc-1295-ipamorelin-combo', why: 'Supports your natural growth hormone pulses, the foundation for lean gains.' },
        { label: 'I break down before I can build up', sub: 'Injuries interrupt every good run', primary: 'bpc-157', alt: 'ipamorelin', why: 'Keeps the repair side strong so you can train consistently enough to grow.' }
      ] },
    { key: 'sleep', tile: 'Sleep and recovery', label: 'Sleep and recovery', short: 'sleep and recovery', sub: 'Waking tired, slow to bounce back', kw: 'sleep sleeping insomnia rest recovery recover tired wake waking body composition shape toning',
      collection: '/collections/poor-recovery-no-visible-shape-change', q: 'Which is closer to your nights?',
      options: [
        { label: 'I sleep, but never wake up restored', sub: 'Light, broken sleep and slow mornings', primary: 'cjc-1295-ipamorelin-combo', alt: 'ipamorelin', why: 'Supports your natural growth hormone rhythm for deeper sleep and better overnight recovery.' },
        { label: 'Training hard, body not responding', sub: 'Sore for days, shape not changing', primary: 'ipamorelin', alt: 'bpc-157', why: 'A gentler growth hormone releasing peptide chosen to support recovery, sleep and body composition.' }
      ] },
    { key: 'gut', tile: 'Gut health', label: 'Gut health', short: 'gut health', sub: 'Bloating, sensitivity, inflammation', kw: 'gut bloating bloated digestion digestive stomach ibs inflammation sensitivity leaky',
      collection: '/collections/gut-issues-bloating-inflammation', q: 'Which is the bigger issue?',
      options: [
        { label: 'The gut itself: bloating and sensitivity', sub: 'Foods that used to be fine no longer are', primary: 'bpc-157', alt: 'glutathione', why: 'Originally studied for gut lining repair, the first choice for digestive resilience.' },
        { label: 'Inflammation and feeling generally run down', sub: 'Puffy, achy, slow to bounce back', primary: 'thymosin-alpha-1', alt: 'nad', why: 'Immune modulation support chosen when low-grade inflammation will not settle.' }
      ] },
    { key: 'immunity', tile: 'Immunity', label: 'Immunity', short: 'immunity', sub: 'Sick often, slow to bounce back', kw: 'immunity immune sick illness colds flu infection infections resilience',
      collection: '/collections/getting-sick-often-slow-recovery', q: 'Which pattern do you recognise?',
      options: [
        { label: 'I catch everything going around', sub: 'Back-to-back colds and infections', primary: 'thymosin-alpha-1', alt: 'glutathione', why: 'Supports immune surveillance so your defences respond the way they should.' },
        { label: 'I get better, then never fully recover', sub: 'Illness or stress leaves a long tail', primary: 'nad', alt: 'glutathione', why: 'Rebuilds the cellular energy reserve that slow recovery keeps draining.' }
      ] },
    { key: 'longevity', tile: 'Longevity', label: 'Longevity', short: 'longevity and healthy aging', sub: 'Age well, stay sharp, stay strong', kw: 'longevity aging ageing healthy anti-aging mitochondria healthspan lifespan cellular',
      collection: '/collections/all', q: 'What matters most right now?',
      options: [
        { label: 'Daily energy and sharpness', sub: 'Feel better now, week to week', primary: 'nad', alt: 'glutathione', why: 'Supports the cellular energy currency that daily performance and focus run on.' },
        { label: 'Long-range resilience', sub: 'Invest in the decades ahead', primary: 'ss31', alt: 'mots-c', why: 'Mitochondrial support chosen for healthy aging at the deepest level.' }
      ] }
  ];
  var GOAL = {};
  GOALS.forEach(function (g) { GOAL[g.key] = g; });

  /* Words people type that are not in a product title. */
  var PRODUCT_WORDS = {
    'tirzepatide': 'weight loss glp-1 glp1 appetite cravings',
    'semaglutide': 'weight loss glp-1 glp1 appetite cravings',
    'mots-c': 'metabolism mitochondria energy weight',
    'amino-1mq': '5-amino-1mq 5 amino fat loss metabolism',
    'bpc-157': 'injury tendon gut repair healing',
    'tb-500': 'injury repair healing tb4 thymosin beta',
    'bpc-157-tb-500-combo': 'injury repair healing stack recovery',
    'nad': 'nad+ energy longevity fatigue aging',
    'ss31': 'ss-31 mitochondria longevity energy',
    'glutathione': 'antioxidant detox skin glow burnout',
    'ghk-cu': 'copper peptide skin hair collagen glow',
    'ipamorelin': 'growth hormone sleep recovery muscle',
    'cjc-1295-ipamorelin-combo': 'growth hormone sleep recovery muscle cjc stack',
    'thymosin-alpha-1': 'immune immunity sick inflammation',
    'accessories': 'pen needles swabs'
  };

  var EXPERIENCE = [
    { key: 'new', label: 'I am new to peptides', sub: 'This would be my first protocol' },
    { key: 'used', label: 'I have used peptides before', sub: 'New to BioLux' },
    { key: 'pen', label: 'I already have a BioLux pen', sub: 'I only need the cartridge' }
  ];
  var AGES = ['18 to 29', '30 to 39', '40 to 49', '50 to 59', '60 plus'];
  var SEXES = [{ key: 'female', label: 'Female' }, { key: 'male', label: 'Male' }, { key: 'na', label: 'Rather not say' }];
  /* The pack and its price are chosen on the result, after the shopper has seen their product and why it fits. */
  var STEPS = ['goal', 'refine', 'also', 'about', 'experience', 'name'];
  var PARTNER_DAYS = 30; /* how long a partner's link is remembered on this device */
  var BUILD_MS = 3300;

  /* ---------- storage ---------- */
  function read(store, key) { try { return JSON.parse(window[store].getItem(key)); } catch (e) { return null; } }
  function write(store, key, val) { try { window[store].setItem(key, JSON.stringify(val)); } catch (e) {} }
  function drop(store, key) { try { window[store].removeItem(key); } catch (e) {} }

  function track(event, data) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: event }, data || {})); } catch (e) {}
  }

  /* ================= home: goal chips follow the card in view ================= */
  (function chips() {
    var nav = $('[data-bx-chips]');
    if (!nav) return;
    var chipFor = {};
    $$('[data-bx-chip]', nav).forEach(function (c) { chipFor[c.getAttribute('data-bx-chip')] = c; });
    function setCurrent(id) {
      for (var k in chipFor) {
        if (k === id) chipFor[k].setAttribute('aria-current', 'true'); else chipFor[k].removeAttribute('aria-current');
      }
      var chip = chipFor[id];
      if (!chip) return;
      var target = chip.offsetLeft - (nav.clientWidth - chip.offsetWidth) / 2;
      if (nav.scrollTo) nav.scrollTo({ left: target, behavior: 'smooth' });
    }
    if (!('IntersectionObserver' in window)) return;
    var current = null;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var id = e.target.getAttribute('data-bx-card');
        if (id !== current) { current = id; setCurrent(id); }
      });
    }, { rootMargin: '-35% 0px -55% 0px' });
    $$('[data-bx-card]').forEach(function (card) { io.observe(card); });
  })();

  /* ================= home: with a mouse there is no swipe, so each rail gets a pair of arrows ================= */
  (function rails() {
    var calm = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    $$('[data-bx-railwrap]').forEach(function (wrap) {
      var rail = $('[data-bx-rail]', wrap);
      var prev = $('[data-bx-rail-nav="-1"]', wrap);
      var next = $('[data-bx-rail-nav="1"]', wrap);
      if (!rail || !prev || !next) return;
      var queued = false;
      function paint() {
        queued = false;
        prev.hidden = rail.scrollLeft < 8;
        next.hidden = rail.scrollWidth - rail.clientWidth - rail.scrollLeft < 8;
      }
      function later() { if (!queued) { queued = true; requestAnimationFrame(paint); } }
      function step(dir) { rail.scrollBy({ left: dir * Math.max(160, rail.clientWidth - 170), behavior: calm ? 'auto' : 'smooth' }); }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      rail.addEventListener('scroll', later, { passive: true });
      window.addEventListener('resize', later);
      paint();
    });
  })();

  /* ================= motion: blocks rise in on entry, chips know when they are stuck, images fade in ================= */
  (function motion() {
    var html = document.documentElement;
    if (!html.classList.contains('bx-m')) return;
    var items = $$('[data-bx-rv]');
    var settle = function (el, delay) {
      /* Hand the element back to its own hover and press transitions once it has landed. */
      setTimeout(function () { el.removeAttribute('data-bx-rv'); el.classList.remove('is-in'); el.style.removeProperty('--bx-rv-delay'); }, delay + 900);
    };
    if (!('IntersectionObserver' in window)) { items.forEach(function (el) { el.removeAttribute('data-bx-rv'); }); html.classList.add('bx-m-ready'); return; }
    var io = new IntersectionObserver(function (entries) {
      var n = 0;
      entries.forEach(function (e) {
        if (!e.isIntersecting && e.boundingClientRect.top > 0) return; /* still below the fold */
        var delay = Math.min(n, 6) * 70;
        n += 1;
        e.target.style.setProperty('--bx-rv-delay', delay + 'ms');
        e.target.classList.add('is-in');
        io.unobserve(e.target);
        settle(e.target, delay);
      });
    }, { rootMargin: '0px 240px -6% 240px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
    html.classList.add('bx-m-ready');

    var nav = $('[data-bx-chips]');
    var sentinel = $('[data-bx-chips-sentinel]');
    if (nav && sentinel) {
      var top = parseFloat(getComputedStyle(nav).top) || 0;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        nav.classList.toggle('is-stuck', !e.isIntersecting && e.boundingClientRect.top < top + 2);
      }, { rootMargin: '-' + Math.round(top + 1) + 'px 0px 0px 0px' }).observe(sentinel);
    }

    $$('.bx img').forEach(function (img) {
      if (img.complete) return;
      img.classList.add('bx-img-wait');
      var show = function () { img.classList.remove('bx-img-wait'); };
      img.addEventListener('load', show, { once: true });
      img.addEventListener('error', show, { once: true });
    });
  })();

  /* ================= product page: the chosen pack drives price, buttons and the sticky bar ================= */
  (function productPage() {
    var box = $('[data-bx-pdp]');
    if (!box) return;
    var form = $('[data-bx-pdp-form]', box);
    var dataEl = $('[data-bx-pdp-data]', box);
    if (!form || !dataEl) return;
    var info;
    try { info = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var packs = $$('.bx-pack', box);

    function paint(chosen) {
      var picked = form.querySelector('input[name="id"]:checked');
      var v = picked && info.variants[picked.value];
      if (!v) return;
      var name = v.title.replace(/\s+/g, ' ');
      $$('[data-bx-pdp-price]', box).forEach(function (el) { el.textContent = v.price; });
      var deal = $('[data-bx-pdp-deal]', box);
      var held = deal && window.bxOffer ? window.bxOffer() : null;
      if (deal) {
        deal.hidden = !held || !v.ok;
        if (held && v.ok) deal.textContent = 'R ' + Math.round(v.cents * (1 - held.percent / 100) / 100).toLocaleString('en-US') + (held.partner ? ' with ' + held.partner.split(' ')[0] + '\u2019s ' + held.percent + '%' : ' with your ' + held.percent + '% code');
      }
      $$('[data-bx-pdp-pack]', box).forEach(function (el) { el.textContent = name; });
      $$('[data-bx-pdp-add]', box).forEach(function (btn) { btn.disabled = !v.ok; btn.removeAttribute('aria-busy'); });
      $$('[data-bx-pdp-add-label]', box).forEach(function (el) { el.textContent = v.ok ? 'Add to cart' : 'Sold out'; });
      $$('[data-bx-pdp-add-price]', box).forEach(function (el) { el.textContent = v.ok ? v.price : ''; });
      var meta = $('[data-bx-buybar-meta]', box);
      if (meta) meta.textContent = name + ' \u00B7 ' + v.price;
      var wa = $('[data-bx-pdp-wa]', box);
      if (wa) wa.href = 'https://wa.me/' + info.wa + '?text=' + encodeURIComponent('Hi BioLux! I would like to order ' + info.title + ' (' + name + '). ' + info.url);
      /* The address follows a pack the shopper chose, never a repaint. */
      if (chosen === true) try { var u = new URL(location.href); u.searchParams.set('variant', picked.value); history.replaceState(history.state, '', u); } catch (e) {}
    }
    form.addEventListener('change', function () { paint(true); });
    window.addEventListener('bx:offer', function () { paint(); });
    window.addEventListener('bx:partner', function () { paint(); });

    /* Two-option products: the first option filters which packs show, keeping the same pack where it exists. */
    var strength = $('[data-bx-pdp-strength]', box);
    if (strength) strength.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-value]');
      if (!chip) return;
      var value = chip.getAttribute('data-value');
      var before = form.querySelector('input[name="id"]:checked');
      var wanted = before ? $('.bx-opt__label', before.closest('.bx-pack')).textContent : '';
      var pick = null;
      $$('[data-value]', strength).forEach(function (b) { b.setAttribute('aria-pressed', b === chip ? 'true' : 'false'); });
      $$('[data-bx-packnote]', box).forEach(function (n) { n.hidden = n.getAttribute('data-o1') !== value; });
      packs.forEach(function (pack) {
        var show = pack.getAttribute('data-o1') === value;
        var radio = $('input', pack);
        pack.hidden = !show;
        if (!show || radio.disabled) return;
        if (!pick || $('.bx-opt__label', pack).textContent === wanted) pick = radio;
      });
      if (pick) pick.checked = true;
      paint(true);
    });

    form.addEventListener('submit', function () {
      $$('[data-bx-pdp-add]', box).forEach(function (btn) { btn.setAttribute('aria-busy', 'true'); });
      $$('[data-bx-pdp-add-label]', box).forEach(function (el) { el.textContent = 'Adding'; });
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) paint(); });

    var bar = $('[data-bx-buybar]', box);
    var cta = $('[data-bx-pdp-cta]', box);
    if (bar && cta && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var on = !e.isIntersecting; /* whenever the main buttons are off screen, one stays in reach */
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('button', bar).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
      }).observe(cta);
    }

    var rail = $('[data-bx-gallery-rail]', box);
    var dots = $$('.bx-pdp__dot', box);
    var slides = $$('.bx-pdp__slide', box);
    if (rail && dots.length && 'IntersectionObserver' in window) {
      var seen = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var at = slides.indexOf(e.target);
          dots.forEach(function (d, i) { d.classList.toggle('is-on', i === at); });
        });
      }, { root: rail, threshold: 0.6 });
      slides.forEach(function (sl) { seen.observe(sl); });
    }
    /* Wide screens show one large image over a row of small ones. Choosing a small one makes it the large one.
       Every image is already on screen, so this adds no keyboard stops before the pack choice. */
    if (rail && slides.length > 1) {
      var wide = window.matchMedia('(min-width: 900px)');
      var choose = function (slide) { slides.forEach(function (sl) { sl.classList.toggle('is-main', sl === slide); }); };
      rail.addEventListener('click', function (e) { var sl = e.target.closest('.bx-pdp__slide'); if (sl && wide.matches) choose(sl); });
    }
  })();

  /* ================= partner programme page: what it pays, and the application ================= */
  (function programme() {
    var calc = $('[data-bx-calc]');
    if (calc) {
      var input = $('[data-bx-calc-input]', calc);
      var rand = function (n) { return 'R ' + Math.round(n).toLocaleString('en-US'); };
      var paintCalc = function () {
        var orders = Number(input.value);
        var sales = orders * Number(calc.getAttribute('data-aov'));
        var earn = sales * Number(calc.getAttribute('data-rate')) / 100;
        $('[data-bx-calc-orders]', calc).textContent = orders;
        $('[data-bx-calc-sales]', calc).textContent = rand(sales);
        $('[data-bx-calc-earn]', calc).textContent = rand(earn);
        $('[data-bx-calc-year]', calc).textContent = rand(earn * 12);
      };
      input.addEventListener('input', paintCalc);
      paintCalc();
    }
    var form = $('[data-bx-apply]');
    if (!form) return;
    var error = $('[data-bx-apply-error]');
    var done = $('[data-bx-apply-done]');
    var opened = Date.now();
    var echo = $('[data-bx-handle-echo]', form);
    var page = form.elements.handle;
    var tidy = function (v) { return String(v).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 20); };
    var paintEcho = function () { echo.textContent = tidy(page.value) || tidy(form.elements.name.value.split(' ')[0]) || 'yourname'; };
    page.addEventListener('input', paintEcho);
    form.elements.name.addEventListener('input', paintEcho);
    var fail = function (text) { error.textContent = text; error.hidden = false; };
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      error.hidden = true;
      var f = form.elements;
      var body = {
        name: f.name.value.trim(), email: f.email.value.trim(), phone: f.phone.value.trim(), channel: f.channel.value.trim(), audience: f.audience.value, handle: tidy(f.handle.value),
        why: f.why.value.trim(), website: f.bx_blank.value, terms: f.terms.checked, t: Date.now() - opened,
        role: (form.querySelector('input[name="role"]:checked') || {}).value || '',
        share: $$('input[name="share"]:checked', form).map(function (i) { return i.value; })
      };
      if (body.name.length < 2) return fail('Please enter your full name.');
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(body.email)) return fail('Please enter a valid email address.');
      if (body.phone.replace(/\D/g, '').length < 9) return fail('Please enter your WhatsApp number.');
      if (!body.terms) return fail('Please accept the partner terms.');
      var btn = form.querySelector('button[type="submit"]');
      var label = btn.textContent;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Sending';
      var api = String((window.bxApi || '')).replace(/\/$/, '');
      fetch(api + '/apply', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (out) {
          if (!out.ok) throw new Error(out.error || 'x');
          form.hidden = true;
          done.hidden = false;
          done.focus();
          done.scrollIntoView({ block: 'center' });
        })
        .catch(function (err) {
          btn.removeAttribute('aria-busy');
          btn.textContent = label;
          fail(err && err.message && err.message.length > 3 ? err.message : 'That did not send. Please try again, or message us on WhatsApp.');
        });
    });
  })();

  /* ================= protocol: data ================= */
  var root = $('[data-bx-protocol]');
  var dataEl = document.getElementById('bx-protocol-data');
  if (!root || !dataEl) return;
  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var P = DATA.products || {};
  var R = DATA.routes;
  var searchSheet = $('[data-bx-search]', root);
  var flowSheet = $('[data-bx-flow]', root);
  var dock = $('[data-bx-dock]', root);
  if (!flowSheet.showModal) return; /* very old browsers keep the plain page */

  function money(cents) {
    var amount = (Math.round(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(/\.00$/, '');
    var fmt = String(DATA.moneyFormat || 'R {{amount}}').replace(/<[^>]*>/g, '');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }

  /* ---------- packs: every protocol sells as a starter or double pack, or as refills for an existing pen ---------- */
  function packKind(variant) {
    var t = variant.title.toLowerCase().replace(/\s+/g, ' ');
    if (/refil+ ?x ?2/.test(t)) return 'refill2';
    if (/refil/.test(t)) return 'refill';
    if (/double/.test(t)) return 'double';
    if (/starter/.test(t)) return 'starter';
    return null;
  }
  function pickVariant(product, kind) {
    if (!product) return null;
    var live = product.variants.filter(function (v) { return v.ok; });
    var match = live.filter(function (v) { return packKind(v) === kind; });
    match.sort(function (a, b) { return a.price - b.price; }); /* lowest strength first */
    return match[0] || null;
  }
  function packsFor(product, experience) {
    var single = pickVariant(product, experience === 'pen' ? 'refill' : 'starter');
    var full = pickVariant(product, experience === 'pen' ? 'refill2' : 'double');
    return { single: single, full: full };
  }
  function packName(variant) { return variant.title.split(' / ').pop().replace(/\s+/g, ' ').replace(/Refil\b/, 'Refill'); }

  /* ---------- recommendation ---------- */
  function recommend(a) {
    var goal = GOAL[a.goal];
    if (!goal) return null;
    var opt = goal.options[a.refine] || goal.options[0];
    var handle = P[opt.primary] ? opt.primary : (P[opt.alt] ? opt.alt : null);
    if (!handle) return null;
    var product = P[handle];
    var packs = packsFor(product, a.experience);
    var variant = (a.plan === 'full' && packs.full) || packs.single || packs.full || product.variants.filter(function (v) { return v.ok; })[0];
    if (!variant) return null;
    var altHandle = handle === opt.primary && P[opt.alt] ? opt.alt : null;

    var addon = null;
    (a.also || []).some(function (key) {
      var g = GOAL[key];
      if (!g) return false;
      var pick = [g.options[0].primary, g.options[0].alt, g.options[1] && g.options[1].primary].filter(function (hd) { return hd && hd !== handle && P[hd]; })[0];
      if (!pick) return false;
      var v = packsFor(P[pick], a.experience).single;
      if (!v) return false;
      addon = { handle: pick, product: P[pick], variant: v, goal: g };
      return true;
    });
    return { goal: goal, opt: opt, handle: handle, product: product, variant: variant, packs: packs, alt: altHandle, addon: addon };
  }

  /* ---------- partner: who sent this visitor ---------- */
  var API = String(DATA.api || '').replace(/\/$/, '');
  function partnerNow() {
    var p = read('localStorage', 'bx:partner');
    return p && p.handle && p.code && Date.now() - p.at < PARTNER_DAYS * 864e5 ? p : null;
  }
  /* The partner rides on the cart as well as on this device, so an order placed after a hop to another browser tab still counts. Their code is applied for checkout. */
  function syncPartner(force) {
    var p = partnerNow();
    if (!p || (!force && read('sessionStorage', 'bx:partner-sync') === p.handle)) return;
    write('sessionStorage', 'bx:partner-sync', p.handle);
    /* One after the other: on a first visit both calls would each start a cart, and one would be lost. */
    post(R.cartUpdate, { attributes: { Partner: p.handle } }).catch(function () {}).then(function () {
      return fetch(R.root.replace(/\/$/, '') + '/discount/' + encodeURIComponent(p.code), { credentials: 'same-origin' });
    }).catch(function () {});
  }
  function setPartner(p, countVisit) {
    if (!p || !p.handle || !p.code) return;
    write('localStorage', 'bx:partner', { handle: p.handle, name: p.name || '', code: p.code, at: Date.now() });
    syncPartner(true);
    window.dispatchEvent(new Event('bx:partner'));
    if (countVisit && API && read('sessionStorage', 'bx:partner-hit') !== p.handle) {
      write('sessionStorage', 'bx:partner-hit', p.handle);
      fetch(API + '/hit', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ handle: p.handle }), keepalive: true }).catch(function () {});
    }
    refreshSaved();
  }
  /* Runs once the rest of this script has set itself up. */
  setTimeout(function arrive() {
    var page = $('[data-bx-partner]');
    if (page) {
      try { setPartner(JSON.parse(page.getAttribute('data-bx-partner')), true); } catch (e) {}
      /* A partner can link straight to one goal: the questions then open at that goal. */
      var goal = (location.search.match(/[?&]g=([a-z]{2,12})(&|$)/) || [])[1];
      var cta = $('[data-bx-partner-cta]', page);
      if (goal && GOAL[goal] && cta) cta.setAttribute('data-bx-goal', goal);
      return;
    }
    var ref = (location.search.match(/[?&]ref=([a-z0-9-]{2,24})(&|$)/i) || [])[1];
    if (ref && API) {
      fetch(API + '/p/' + encodeURIComponent(ref.toLowerCase())).then(function (r) { return r.ok ? r.json() : null; }).then(function (p) { setPartner(p, true); }).catch(function () {});
      return;
    }
    syncPartner(false);
  }, 0);

  /* ---------- offer: a real code from the store, held for this device until the time it shows ---------- */
  function deviceId() {
    var id = read('localStorage', 'bx:device');
    if (!id) { id = (Date.now().toString(36) + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2)).slice(0, 32); write('localStorage', 'bx:device', id); }
    return id;
  }
  function offerNow() {
    var percent = Number((DATA.offer || {}).percent) || 10;
    var p = partnerNow();
    if (p) return { code: p.code, percent: percent, partner: p.name, left: null };
    var saved = read('localStorage', 'bx:offer');
    if (!saved || !saved.code || !saved.until) return null;
    var left = saved.until - Date.now();
    return left > 0 ? { code: saved.code, percent: Number(saved.percent) || percent, left: left, ends: saved.until } : null;
  }
  window.bxOffer = offerNow; /* the product page, set up earlier in this file, reads the held offer through this */
  window.dispatchEvent(new Event('bx:offer'));
  /* Asks once per result. The store decides: a fresh code, the one already held, or none. */
  var offerAsk = null;
  function ensureOffer() {
    if (offerNow() || !API) return Promise.resolve(offerNow());
    if (offerAsk) return offerAsk;
    var ask = function () {
      return fetch(API + '/offer', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ device: deviceId() }) })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    };
    /* No answer at all gets one more try. An answer that says there is no code is final. */
    offerAsk = ask()
      .then(function (d) { return d || new Promise(function (go) { setTimeout(go, 1200); }).then(ask); })
      .then(function (d) {
        if (d && d.offer && d.offer.code) write('localStorage', 'bx:offer', { code: d.offer.code, percent: d.offer.percent, until: new Date(d.offer.until).getTime() });
        return offerNow();
      })
      .catch(function () { return null; })
      .then(function (offer) { offerAsk = null; return offer; });
    return offerAsk;
  }
  function clock(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    return p(Math.floor(s / 3600)) + ':' + p(Math.floor(s / 60) % 60) + ':' + p(s % 60);
  }
  var ticker = null;
  function tick() {
    var nodes = $$('[data-bx-countdown]');
    var offer = offerNow();
    if (!nodes.length) { clearInterval(ticker); ticker = null; return; }
    if (!offer || offer.left === null) {
      clearInterval(ticker); ticker = null;
      /* The promise was a code until the timer ends. When it ends on the cart page, the code comes off the cart too. */
      if (nodes.some(function (n) { return n.hasAttribute('data-bx-cart-timer'); })) post(R.cartUpdate, { discount: '' }).then(function () { location.reload(); }).catch(function () {});
      refreshSaved();
      if (flowSheet.open && state.step === 'result') render('result', 'none');
      return;
    }
    nodes.forEach(function (n) { n.textContent = clock(offer.left); });
  }
  function startTicker() { if (!ticker) ticker = setInterval(tick, 1000); tick(); }

  /* ---------- cart page: change lines in place, keep the next step in reach ---------- */
  (function cartPage() {
    var box = $('[data-bx-cart]');
    if (!box) return;
    var watchers = [];
    function reload() { location.reload(); }
    function refresh() {
      return fetch(location.pathname + '?section_id=' + encodeURIComponent(box.getAttribute('data-section')), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('section'); return r.text(); })
        .then(function (html) {
          var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-bx-cart]');
          if (!next || !next.querySelector('.bx-line')) return reload();
          box.innerHTML = next.innerHTML; /* our own section, rendered by the store */
          box.classList.remove('is-busy');
          wire();
        });
    }
    function change(key, quantity) {
      box.classList.add('is-busy');
      post(R.cartChange, { id: key, quantity: quantity }).then(function (r) { if (!r.ok) throw new Error('change'); return refresh(); }).catch(reload);
    }
    box.addEventListener('click', function (e) {
      var line = e.target.closest('.bx-line');
      if (!line || box.classList.contains('is-busy')) return;
      var qty = e.target.closest('[data-bx-qty]');
      var swap = e.target.closest('[data-bx-swap]');
      if (qty) {
        var shownQty = $('.bx-qty__n', line);
        var step = qty.classList.contains('bx-line__remove') ? null : (qty.getAttribute('aria-label') === 'One more' ? 1 : -1);
        var target = step === null ? 0 : Math.max(0, Number(shownQty.textContent) + step);
        if (step !== null && target > 0) {
          /* Show the number at once and send only the last one, so fast taps all count. */
          shownQty.textContent = target;
          clearTimeout(line.bxTimer);
          line.bxTimer = setTimeout(function () { change(line.getAttribute('data-key'), target); }, 450);
        } else { clearTimeout(line.bxTimer); change(line.getAttribute('data-key'), 0); }
      }
      else if (swap) {
        box.classList.add('is-busy');
        track('cart_pack_upgrade', { variant: swap.getAttribute('data-bx-swap') });
        post(R.cartChange, { id: line.getAttribute('data-key'), quantity: 0 })
          .then(function (r) { if (!r.ok) throw new Error('remove'); return post(R.cartAdd, { items: [{ id: Number(swap.getAttribute('data-bx-swap')), quantity: 1 }] }); })
          .then(function (r) { if (!r.ok) throw new Error('add'); return refresh(); })
          .catch(reload);
      }
    });
    /* The eligibility check owns the checkout button. The bar follows its state and never sets it. */
    function wire() {
      watchers.forEach(function (w) { w.disconnect(); });
      watchers = [];
      var bar = $('[data-bx-cartbar]', box);
      var gate = $('[data-elig-checkout]');
      if (bar && gate) {
        var go = $('[data-bx-cartbar-go]', bar);
        var note = $('[data-bx-cartbar-note]', bar);
        var before = note.textContent;
        var ready = function () { return !gate.classList.contains('is-disabled') && gate.getAttribute('aria-disabled') !== 'true'; };
        var wide = window.matchMedia('(min-width: 900px)');
        /* On a phone the check is further down, so Continue takes the shopper to it. On wide screens it is beside the button, so the button says what is left to do. */
        var paint = function () {
          var done = ready();
          go.textContent = done ? 'Checkout' : (wide.matches ? 'Answer the questions to check out' : 'Continue');
          go.classList.toggle('is-waiting', !done);
          note.textContent = done ? 'Check complete' : before;
        };
        paint();
        go.addEventListener('click', function () {
          if (ready()) { gate.click(); return; }
          var card = gate.closest('.elig-card') || gate;
          card.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
          card.classList.remove('bx-nudge');
          void card.offsetWidth; /* restart the highlight when pressed again */
          card.classList.add('bx-nudge');
        });
        if (window.MutationObserver) { var seen = new MutationObserver(paint); seen.observe(gate, { attributes: true }); watchers.push(seen); }
        if ('IntersectionObserver' in window) {
          /* On wide screens the bar is part of the order summary, so it is always in reach. */
          var away = false;
          var show = function () {
            var on = wide.matches || away;
            bar.classList.toggle('is-on', on);
            bar.setAttribute('aria-hidden', on ? 'false' : 'true');
            go.tabIndex = on ? 0 : -1;
          };
          var inView = new IntersectionObserver(function (entries) { away = !entries[0].isIntersecting; show(); });
          inView.observe(gate);
          watchers.push(inView);
          var turn = function () { show(); paint(); };
          if (wide.addEventListener) { wide.addEventListener('change', turn); watchers.push({ disconnect: function () { wide.removeEventListener('change', turn); } }); }
          show();
        }
      }
      var offer = offerNow();
      $$('[data-bx-cart-timer]', box).forEach(function (el) {
        if (!offer || offer.left === null || el.getAttribute('data-bx-cart-timer').toUpperCase() !== offer.code) return;
        el.hidden = false;
        el.setAttribute('data-bx-countdown', '');
        startTicker();
      });
    }
    setTimeout(wire, 0); /* after the rest of this script has set itself up */
  })();

  /* ---------- saved protocol chip above the dock ---------- */
  var savedBtn = $('[data-bx-saved]', root);
  function refreshSaved() {
    var saved = read('localStorage', 'bx:protocol');
    var rec = saved && recommend(saved.answers);
    if (!rec) { savedBtn.hidden = true; return; }
    var offer = offerNow();
    $('[data-bx-saved-name]', savedBtn).textContent = 'Your protocol: ' + rec.product.title;
    var time = $('[data-bx-saved-time]', savedBtn);
    var timed = !!offer && offer.left !== null;
    time.hidden = !timed;
    if (timed) { time.setAttribute('data-bx-countdown', ''); startTicker(); } else time.removeAttribute('data-bx-countdown');
    savedBtn.hidden = false;
  }
  savedBtn.addEventListener('click', function () {
    var saved = read('localStorage', 'bx:protocol');
    if (!saved) return;
    state.answers = saved.answers;
    openFlow('result');
  });

  /* ---------- the dock steps aside for the footer ---------- */
  (function () {
    var footer = $('.shopify-section-group-footer-group') || $('footer');
    if (!footer || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      dock.classList.toggle('is-away', entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -80px 0px' }).observe(footer);
  })();

  /* ---------- sheets: history, viewport and scroll lock shared by search and flow ---------- */
  var depth = 0; /* history entries this script has pushed and not yet unwound */
  var unwinding = false; /* true between closing and the browser finishing the walk back */
  function push(name) { depth += 1; try { history.pushState({ bx: name, i: depth }, ''); } catch (e) {} }
  function fitViewport() {
    var vv = window.visualViewport;
    [searchSheet, flowSheet].forEach(function (sheet) {
      if (!sheet.open || !vv) return;
      sheet.style.setProperty('--bx-vvh', vv.height + 'px');
      sheet.style.setProperty('--bx-vvt', vv.offsetTop + 'px');
    });
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', fitViewport);
    window.visualViewport.addEventListener('scroll', fitViewport);
  }
  function showSheet(sheet) {
    if (sheet.open) return;
    sheet.showModal();
    document.documentElement.classList.add('bx-lock');
    fitViewport();
  }
  function hideSheet(sheet) {
    if (sheet.open) sheet.close();
    if (!searchSheet.open && !flowSheet.open) document.documentElement.classList.remove('bx-lock');
  }
  /* Closing from the UI unwinds our history entries; the popstate that follows finds nothing open. */
  function closeAll() {
    clearTimeout(buildTimer);
    hideSheet(searchSheet);
    hideSheet(flowSheet);
    var n = depth;
    depth = 0;
    if (n > 0) {
      unwinding = true;
      setTimeout(function () { unwinding = false; }, 600);
      try { history.go(-n); } catch (e) { unwinding = false; }
    }
  }
  window.addEventListener('popstate', function (e) {
    var st = e.state && e.state.bx ? e.state : null;
    unwinding = false;
    if (!searchSheet.open && !flowSheet.open) { if (!st) depth = 0; return; }
    depth = st ? st.i : 0;
    if (searchSheet.open) { hideSheet(searchSheet); return; }
    if (st && st.bx !== 'search' && canShow(st.bx)) { clearTimeout(buildTimer); render(st.bx, 'back'); return; }
    clearTimeout(buildTimer);
    hideSheet(flowSheet);
  });
  [searchSheet, flowSheet].forEach(function (sheet) {
    sheet.addEventListener('cancel', function (e) { e.preventDefault(); closeAll(); });
    /* On wide screens the sheet is a window over the page. A press on the page behind it closes it.
       A phone's sheet fills the screen, and with the keyboard up it covers only the visible part, so a tap outside that part must do nothing. */
    sheet.addEventListener('mousedown', function (e) {
      if (e.target !== sheet || !window.matchMedia('(min-width: 900px)').matches) return;
      var r = sheet.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeAll();
    });
    $$('[data-bx-close]', sheet).forEach(function (b) { b.addEventListener('click', closeAll); });
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { busy = false; if (flowSheet.open && state.step === 'result') render('result', 'none'); } });

  /* ================= search ================= */
  var input = $('[data-bx-search-input]', root);
  var list = $('[data-bx-search-list]', root);
  var clearBtn = $('[data-bx-search-clear]', root);
  var STATS = DATA.collections || {};
  var POPULAR_GOALS = ['weight', 'menopause', 'injury', 'energy', 'skin'];
  var POPULAR_PRODUCTS = ['tirzepatide', 'semaglutide', 'bpc-157-tb-500-combo', 'cjc-1295-ipamorelin-combo'];

  function goalMeta(g) {
    var st = STATS[g.collection.split('/').pop()];
    return st && st.count ? st.count + (st.count === 1 ? ' protocol' : ' protocols') + ' from ' + money(st.min) : g.sub;
  }
  /* The goal each protocol is first suggested for, shown beside its price. */
  var PRODUCT_GOAL = {};
  GOALS.forEach(function (g) {
    g.options.forEach(function (o) { [o.primary, o.alt].forEach(function (hd) { if (hd && !PRODUCT_GOAL[hd]) PRODUCT_GOAL[hd] = g.label; }); });
  });
  function productMeta(handle, goalLabel) {
    var p = P[handle];
    var goal = goalLabel || PRODUCT_GOAL[handle];
    return 'from ' + money(p.min) + (goal ? ' · ' + goal : '');
  }

  function wordsOf(text) { return String(text).toLowerCase().replace(/[^a-z0-9+\s-]/g, ' ').split(/[\s-]+/).filter(Boolean); }
  /* Words people type around what they mean. They never decide a match. */
  var FILLER = { a: 1, an: 1, the: 1, my: 1, i: 1, me: 1, is: 1, it: 1, to: 1, 'for': 1, of: 1, and: 1, or: 1, 'with': 1, 'in': 1, on: 1, 'this': 1, that: 1, 'do': 1, does: 1, can: 1, wont: 1, cant: 1, not: 1, no: 1, have: 1, has: 1, need: 1, want: 1, get: 1, buy: 1, best: 1, some: 1, help: 1, how: 1, what: 1, im: 1, am: 1, are: 1 };
  function meaning(tokens) { var kept = tokens.filter(function (t) { return !FILLER[t]; }); return kept.length ? kept : tokens; }
  /* "bpc157" is how many people type "BPC-157". */
  function compact(text) { return String(text).toLowerCase().replace(/[^a-z0-9]/g, ''); }
  var INDEX = [];
  GOALS.forEach(function (g) {
    INDEX.push({ type: 'goal', key: g.key, title: g.label, words: wordsOf([g.label, g.tile, g.sub, g.kw, g.short].concat(g.options.map(function (o) { return o.label + ' ' + o.sub; })).join(' ')) });
  });
  Object.keys(P).forEach(function (handle) {
    var packs = P[handle].variants.map(function (v) { return v.title; }).join(' ');
    INDEX.push({ type: 'product', handle: handle, title: P[handle].title, words: wordsOf([P[handle].title, handle, PRODUCT_WORDS[handle] || '', PRODUCT_GOAL[handle] || '', packs, compact(P[handle].title), compact(handle)].join(' ')) });
  });
  if (R.faq) INDEX.push({ type: 'page', title: 'Questions and answers', meta: 'Safety, doctors, delivery and how it works', url: R.faq, words: wordsOf('questions answers faq faqs safe safety legal doctor doctors consult consultation prescription script pharmacy pharmacist registered sahpra side effects delivery shipping courier returns refund how works price prices pricing cost payment medical aid') });
  /* One slip is forgiven on longer words: a missing, extra, swapped or wrong letter. */
  function near(a, b) {
    if (Math.abs(a.length - b.length) > 1) return false;
    var i = 0, j = 0, edits = 0;
    while (i < a.length && j < b.length) {
      if (a[i] === b[j]) { i += 1; j += 1; continue; }
      edits += 1;
      if (edits > 1) return false;
      if (a.length > b.length) i += 1;
      else if (a.length < b.length) j += 1;
      else if (a[i + 1] === b[j] && a[i] === b[j + 1]) { i += 2; j += 2; }
      else { i += 1; j += 1; }
    }
    return edits + (a.length - i) + (b.length - j) <= 1;
  }
  function tokenScore(token, words) {
    var best = 0;
    for (var i = 0; i < words.length; i++) {
      var w = words[i];
      if (w === token) return 3;
      if (w.indexOf(token) === 0) best = Math.max(best, 2);
      else if (token.length >= 5 && (near(token, w) || near(token, w.slice(0, token.length)))) best = Math.max(best, 1);
    }
    return best;
  }
  /* A sentence finds what any of its words find. Entries matching more of the words come first, and when some entry matches every word only those are shown. */
  function find(tokens) {
    var phrase = tokens.join(' ');
    var hits = [];
    var most = 0;
    INDEX.forEach(function (entry) {
      var total = 0;
      var matched = 0;
      for (var i = 0; i < tokens.length; i++) {
        var s = tokenScore(tokens[i], entry.words);
        if (s) { matched += 1; total += s; }
      }
      if (!matched) return;
      if (entry.title.toLowerCase().indexOf(phrase) === 0) total += 3;
      most = Math.max(most, matched);
      hits.push({ entry: entry, matched: matched, score: total });
    });
    if (most === tokens.length) hits = hits.filter(function (x) { return x.matched === most; });
    hits.sort(function (a, b) { return b.matched - a.matched || b.score - a.score; });
    return hits.map(function (x) { return x.entry; });
  }
  /* The store index also returns loose guesses. Keep a result only when the typed words are really in its text. */
  function textHas(tokens, item) {
    if (!tokens.length) return false;
    var words = wordsOf([item.title, item.body, item.summary_html, item.tags, item.type].join(' ').replace(/<[^>]+>/g, ' '));
    return tokens.every(function (t) { return tokenScore(t, words) > 0; });
  }
  /* Bold the part of a title the visitor typed. */
  function marked(text, tokens) {
    var frag = document.createDocumentFragment();
    if (!tokens || !tokens.length) { frag.appendChild(document.createTextNode(text)); return frag; }
    var re = new RegExp('(^|[^a-z0-9])(' + tokens.map(function (t) { return t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')', 'ig');
    var at = 0, m;
    while ((m = re.exec(text))) {
      var start = m.index + m[1].length;
      frag.appendChild(document.createTextNode(text.slice(at, start)));
      frag.appendChild(h('mark', { text: m[2] }));
      at = start + m[2].length;
    }
    frag.appendChild(document.createTextNode(text.slice(at)));
    return frag;
  }

  function recent() { var r = read('localStorage', 'bx:recent'); return Array.isArray(r) ? r.filter(function (x) { return typeof x === 'string'; }).slice(0, 4) : []; }
  function remember(q) {
    q = q.trim().slice(0, 40);
    if (q.length < 2) return;
    write('localStorage', 'bx:recent', [q].concat(recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); })).slice(0, 4));
  }

  function row(opts) {
    var icon = h('span', { class: 'bx-row__icon' + (opts.gold ? ' bx-row__icon--gold' : '') });
    if (opts.img) icon.appendChild(h('img', { src: opts.img, alt: '', loading: 'lazy', width: 44, height: 44 }));
    else icon.innerHTML = svg(ICON[opts.icon] || ICON.search);
    var title = h('span', { class: 'bx-row__title' });
    title.appendChild(marked(opts.title, opts.tokens));
    var text = h('span', { class: 'bx-row__text' }, title, opts.meta ? h('span', { class: 'bx-row__meta', text: opts.meta }) : null);
    var attrs = { class: 'bx-row' };
    if (opts.href) { attrs.href = opts.href; if (opts.external) { attrs.target = '_blank'; attrs.rel = 'noopener'; } }
    else attrs.type = 'button';
    var el = h(opts.href ? 'a' : 'button', attrs, icon, text);
    el.addEventListener('click', function () { remember(input.value); if (opts.onPick) opts.onPick(); });
    return el;
  }
  function goalRow(g, tokens) {
    return row({ icon: g.key, title: g.label, meta: goalMeta(g), tokens: tokens, onPick: function () {
      track('protocol_search', { pick: 'goal', value: g.key });
      hideSheet(searchSheet);
      state.answers = { goal: g.key };
      openFlow('refine', true);
    } });
  }
  function productRow(handle, tokens, goalLabel) {
    var p = P[handle];
    return row({ img: p.img, title: p.title, meta: productMeta(handle, goalLabel), tokens: tokens, href: p.url, onPick: function () { track('protocol_search', { pick: 'product', value: handle }); } });
  }
  function label(text) { return h('p', { class: 'bx-search__label', text: text }); }

  /* The store's own index adds what the local list cannot know: articles, pages and matches in descriptions. */
  var remoteCache = {};
  var remoteTimer = null;
  var remoteCtl = null;
  function fetchRemote(q) {
    clearTimeout(remoteTimer);
    if (remoteCtl) remoteCtl.abort();
    if (compact(q).length < 2 || remoteCache[q] || !window.fetch) return;
    remoteTimer = setTimeout(function () {
      remoteCtl = window.AbortController ? new AbortController() : null;
      var url = R.search.replace(/\/$/, '') + '/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,article,page&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, { signal: remoteCtl ? remoteCtl.signal : undefined, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.resources) return;
          remoteCache[q] = d.resources.results || {};
          if (input.value.trim() === q) renderSearch();
        })
        .catch(function () {});
    }, 160);
  }

  function renderSearch() {
    input.removeAttribute('aria-activedescendant');
    var q = input.value.trim();
    if (clearBtn) clearBtn.hidden = !q;
    list.textContent = '';
    if (!q) {
      list.appendChild(row({ icon: 'spark', gold: true, title: 'Find my protocol', meta: 'Six short questions', onPick: function () { hideSheet(searchSheet); state.answers = {}; openFlow('goal', true); } }));
      var past = recent();
      if (past.length) {
        list.appendChild(label('Recent'));
        var chips = h('div', { class: 'bx-search__chips' });
        past.forEach(function (text) {
          chips.appendChild(h('button', { type: 'button', class: 'bx-chip', text: text, onclick: function () { input.value = text; renderSearch(); fetchRemote(text); input.focus(); } }));
        });
        list.appendChild(chips);
      }
      list.appendChild(label('Popular goals'));
      POPULAR_GOALS.forEach(function (k) { if (GOAL[k]) list.appendChild(goalRow(GOAL[k])); });
      var top = POPULAR_PRODUCTS.filter(function (hd) { return P[hd]; });
      if (top.length) { list.appendChild(label('Popular protocols')); top.forEach(function (hd) { list.appendChild(productRow(hd)); }); }
      return;
    }
    var tokens = meaning(wordsOf(q));
    var hits = tokens.length ? find(tokens) : [];
    var goals = hits.filter(function (x) { return x.type === 'goal'; }).slice(0, 4);
    var handles = hits.filter(function (x) { return x.type === 'product'; }).map(function (x) { return x.handle; });
    var remote = remoteCache[q] || {};
    /* A matched goal brings its own protocols, then the store index adds matches from descriptions. */
    var inGoal = {};
    if (goals.length) GOAL[goals[0].key].options.forEach(function (o) {
      [o.primary, o.alt].forEach(function (hd) {
        if (!hd || !P[hd]) return;
        inGoal[hd] = GOAL[goals[0].key].label;
        if (handles.indexOf(hd) === -1) handles.push(hd);
      });
    });
    (remote.products || []).forEach(function (x) { if (P[x.handle] && handles.indexOf(x.handle) === -1 && textHas(tokens, x)) handles.push(x.handle); });
    handles = handles.slice(0, 6);

    if (goals.length) { list.appendChild(label('Goals')); goals.forEach(function (x) { list.appendChild(goalRow(GOAL[x.key], tokens)); }); }
    if (handles.length) { list.appendChild(label('Protocols')); handles.forEach(function (hd) { list.appendChild(productRow(hd, tokens, inGoal[hd])); }); }
    var articles = (remote.articles || []).filter(function (a) { return textHas(tokens, a); }).slice(0, 3);
    if (articles.length) {
      list.appendChild(label('Journal'));
      articles.forEach(function (a) { list.appendChild(row({ img: a.image || null, icon: 'guide', title: a.title, tokens: tokens, href: a.url })); });
    }
    /* Our own questions page first, then store pages that really hold the words. Checkout step pages are not places to land. */
    var help = hits.filter(function (x) { return x.type === 'page'; });
    var pages = (remote.pages || []).filter(function (pg) { return textHas(tokens, pg) && !/checkout/i.test(pg.url) && !help.some(function (x) { return pg.url.indexOf(x.url) === 0; }); }).slice(0, 3);
    if (help.length || pages.length) {
      list.appendChild(label('Help'));
      help.forEach(function (x) { list.appendChild(row({ icon: 'guide', title: x.title, meta: x.meta, tokens: tokens, href: x.url })); });
      pages.forEach(function (pg) { list.appendChild(row({ icon: 'guide', title: pg.title, tokens: tokens, href: pg.url })); });
    }
    var found = goals.length + handles.length + articles.length + pages.length + help.length;
    list.appendChild(label(found ? 'More' : 'No match yet'));
    list.appendChild(row({ icon: 'search', title: 'Search the store for “' + q + '”', href: R.search + '?q=' + encodeURIComponent(q) }));
    if (!found) {
      list.appendChild(row({ icon: 'spark', gold: true, title: 'Find my protocol', meta: 'Answer a few questions instead', onPick: function () { hideSheet(searchSheet); state.answers = {}; openFlow('goal', true); } }));
      list.appendChild(row({ icon: 'chat', title: 'Ask us on WhatsApp', meta: 'A real person will point you the right way', external: true,
        href: 'https://wa.me/' + DATA.wa + '?text=' + encodeURIComponent('Hi BioLux! I am looking for help with: ' + q) }));
    }
  }
  input.addEventListener('input', function () { renderSearch(); list.scrollTop = 0; fetchRemote(input.value.trim()); });
  if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; renderSearch(); input.focus(); });
  /* Arrow keys walk the suggestions; Enter takes the highlighted one or falls through to store search. */
  input.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter') return;
    var rows = $$('.bx-row', list);
    var at = rows.findIndex(function (r) { return r.getAttribute('data-active') === 'true'; });
    if (e.key === 'Enter') { if (at > -1) { e.preventDefault(); rows[at].click(); } return; }
    e.preventDefault();
    if (!rows.length) return;
    var next = e.key === 'ArrowDown' ? (at + 1) % rows.length : (at <= 0 ? rows.length - 1 : at - 1);
    rows.forEach(function (r, i) { r.id = 'bx-row-' + i; if (i === next) r.setAttribute('data-active', 'true'); else r.removeAttribute('data-active'); });
    input.setAttribute('aria-activedescendant', rows[next].id);
    rows[next].scrollIntoView({ block: 'nearest' });
  });
  $('[data-bx-search-form]', root).addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); else remember(input.value); });
  function openSearch() {
    if (searchSheet.open) return;
    input.value = '';
    renderSearch();
    showSheet(searchSheet);
    input.focus(); /* inside the tap, so phones raise the keyboard */
    push('search');
    track('protocol_search_open');
  }
  /* One search for the whole store: the header's magnifier opens this sheet too. */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('a[aria-controls^="header-search"]');
    if (!trigger || unwinding) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openSearch();
  }, true);

  /* With a keyboard, a slash or Ctrl K opens search from anywhere on the page. */
  document.addEventListener('keydown', function (e) {
    if (e.defaultPrevented || searchSheet.open || flowSheet.open || unwinding) return;
    var slash = e.key === '/' && !e.ctrlKey && !e.metaKey && !e.altKey;
    var combo = (e.key === 'k' || e.key === 'K') && (e.ctrlKey || e.metaKey) && !e.altKey && !e.shiftKey;
    if (!slash && !combo) return;
    var el = e.target;
    if (slash && el && (el.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName))) return;
    e.preventDefault();
    openSearch();
  });

  /* ================= flow ================= */
  var body = $('[data-bx-body]', root);
  var foot = $('[data-bx-foot]', root);
  var backBtn = $('[data-bx-back]', root);
  var bar = $('[data-bx-progress-bar]', root);
  var progress = $('[data-bx-progress]', root);
  var state = { step: 'goal', answers: read('sessionStorage', 'bx:flow') || {} };
  var busy = false;
  var buildTimer = null;
  var addonOn = false;

  function keep() { write('sessionStorage', 'bx:flow', state.answers); }
  /* A step can only be shown once everything before it has an answer. */
  function canShow(step) {
    var a = state.answers;
    if (step === 'goal') return true;
    if (!GOAL[a.goal]) return false;
    if (step === 'refine') return true;
    if (a.refine == null || !GOAL[a.goal].options[a.refine]) return false;
    if (step === 'also' || step === 'about') return true;
    if (!a.age || !a.sex) return false;
    if (step === 'experience') return true;
    if (!a.experience) return false;
    if (step === 'name' || step === 'building') return true;
    return step === 'result' && !!recommend(a);
  }
  function after(step) {
    var i = STEPS.indexOf(step);
    return STEPS[i + 1] || 'building';
  }
  function advance(from) {
    keep();
    var next = after(from);
    if (next === 'building') { render('building', 'forward'); return; }
    push(next);
    render(next, 'forward');
  }
  function openFlow(step, replaceSearch) {
    if (!canShow(step)) step = 'goal';
    addonOn = false;
    showSheet(flowSheet);
    /* Coming from search, its history entry becomes the flow's first entry. */
    if (replaceSearch && depth > 0) { try { history.replaceState({ bx: step, i: depth }, ''); } catch (e) {} }
    else push(step);
    render(step, 'forward');
    track('protocol_finder_start', { step: step });
  }

  function option(o) {
    var el = h('button', { type: 'button', class: 'bx-opt' + (o.tile ? ' bx-opt--tile' : '') + (o.chip ? ' bx-opt--chip' : ''), 'aria-pressed': o.on ? 'true' : 'false' });
    if (o.icon) el.appendChild(h('span', { class: 'bx-opt__icon', svg: svg(ICON[o.icon] || ICON.spark) }));
    if (o.chip) el.appendChild(document.createTextNode(o.label));
    else {
      el.appendChild(h('span', { class: 'bx-opt__text' },
        h('span', { class: 'bx-opt__label', text: o.label }),
        o.sub ? h('span', { class: 'bx-opt__sub', text: o.sub }) : null,
        o.tag ? h('span', { class: 'bx-opt__tag', text: o.tag }) : null));
      if (o.price) el.appendChild(h('span', { class: 'bx-opt__price' }, o.was ? h('span', { class: 'bx-opt__was', text: o.was }) : null, h('span', { text: o.price })));
      if (!o.tile) el.appendChild(h('span', { class: 'bx-opt__mark', svg: svg(ICON.check, 14) }));
    }
    el.addEventListener('click', function () { o.onPick(el); });
    return el;
  }
  /* Single choice: show the selection for a beat, then move on. */
  function choose(group, el, done) {
    if (group.getAttribute('data-locked')) return;
    group.setAttribute('data-locked', '1');
    $$('.bx-opt', group).forEach(function (b) { b.setAttribute('aria-pressed', b === el ? 'true' : 'false'); });
    setTimeout(done, 170);
  }
  function head(title, sub, lead) {
    return [lead ? h('p', { class: 'bx-step__lead', text: lead }) : null, h('h2', { class: 'bx-step__title', text: title, tabindex: '-1' }), sub ? h('p', { class: 'bx-step__sub', text: sub }) : null];
  }
  function primaryBtn(label, onClick, disabled) {
    return h('button', { type: 'button', class: 'bx-btn bx-btn--ink bx-btn--block', text: label, disabled: disabled, onclick: onClick });
  }

  var VIEW = {
    goal: function (a) {
      var grid = h('div', { class: 'bx-opts bx-opts--grid', role: 'group', 'aria-label': 'Your goal' });
      GOALS.forEach(function (g) {
        grid.appendChild(option({ tile: true, icon: g.key, label: g.tile, on: a.goal === g.key, onPick: function (el) {
          choose(grid, el, function () {
            if (a.goal !== g.key) { a.refine = null; a.also = []; a.alsoSeen = false; }
            a.goal = g.key;
            track('protocol_finder_step', { concern: g.key });
            advance('goal');
          });
        } }));
      });
      return { nodes: head('What would you most like to change?', 'Pick the one that matters most right now.').concat(grid) };
    },
    refine: function (a) {
      var goal = GOAL[a.goal];
      var group = h('div', { class: 'bx-opts', role: 'group', 'aria-label': goal.q });
      goal.options.forEach(function (o, i) {
        group.appendChild(option({ label: o.label, sub: o.sub, on: a.refine === i, onPick: function (el) {
          choose(group, el, function () { a.refine = i; advance('refine'); });
        } }));
      });
      return { nodes: head(goal.q, null, goal.label).concat(group) };
    },
    also: function (a) {
      a.also = a.also || [];
      var group = h('div', { class: 'bx-opts bx-opts--grid', role: 'group', 'aria-label': 'Other goals' });
      var cta = primaryBtn(a.also.length ? 'Continue' : 'Nothing else, continue', function () { a.alsoSeen = true; advance('also'); });
      GOALS.filter(function (g) { return g.key !== a.goal; }).forEach(function (g) {
        group.appendChild(option({ multi: true, tile: true, icon: g.key, label: g.tile, on: a.also.indexOf(g.key) !== -1, onPick: function (el) {
          var at = a.also.indexOf(g.key);
          if (at !== -1) a.also.splice(at, 1);
          else { if (a.also.length >= 2) { var first = a.also.shift(); var old = $('[data-key="' + first + '"]', group); if (old) old.setAttribute('aria-pressed', 'false'); } a.also.push(g.key); }
          el.setAttribute('aria-pressed', a.also.indexOf(g.key) !== -1 ? 'true' : 'false');
          cta.textContent = a.also.length ? 'Continue' : 'Nothing else, continue';
          keep();
        } }));
        group.lastChild.setAttribute('data-key', g.key);
      });
      return { nodes: head('Is there anything else you would like to work on?', 'Optional. Choose up to two.').concat(group), foot: [cta] };
    },
    about: function (a) {
      if (a.goal === 'menopause') a.sex = 'female';
      var cta = primaryBtn('Continue', function () { advance('about'); }, !(a.age && a.sex));
      var nodes = head('A little about you', 'This shapes what we suggest. It stays with your order.');
      function chips(labelText, items, current, onPick) {
        var group = h('div', { class: 'bx-opts bx-opts--chips', role: 'group', 'aria-label': labelText });
        items.forEach(function (it) {
          group.appendChild(option({ chip: true, label: it.label, on: current() === it.key, onPick: function (el) {
            onPick(it.key);
            $$('.bx-opt', group).forEach(function (b) { b.setAttribute('aria-pressed', b === el ? 'true' : 'false'); });
            cta.disabled = !(a.age && a.sex);
            keep();
          } }));
        });
        nodes.push(h('p', { class: 'bx-step__group', text: labelText }), group);
      }
      chips('Your age', AGES.map(function (x) { return { key: x, label: x }; }), function () { return a.age; }, function (k) { a.age = k; });
      if (a.goal !== 'menopause') chips('Sex', SEXES, function () { return a.sex; }, function (k) { a.sex = k; });
      return { nodes: nodes, foot: [cta] };
    },
    experience: function (a) {
      var group = h('div', { class: 'bx-opts', role: 'group', 'aria-label': 'Experience with peptides' });
      EXPERIENCE.forEach(function (x) {
        group.appendChild(option({ label: x.label, sub: x.sub, on: a.experience === x.key, onPick: function (el) {
          choose(group, el, function () {
            if (a.experience !== x.key) a.plan = null;
            a.experience = x.key;
            advance('experience');
          });
        } }));
      });
      return { nodes: head('Have you used peptides before?', 'So we suggest the right pack to start with.').concat(group) };
    },
    name: function (a) {
      var field = h('input', { class: 'bx-field', type: 'text', name: 'given-name', autocomplete: 'given-name', autocapitalize: 'words', spellcheck: 'false', maxlength: '30', placeholder: 'First name', 'aria-label': 'First name', enterkeyhint: 'done' });
      field.value = a.name || '';
      function go() { a.name = field.value.trim().slice(0, 30); advance('name'); }
      field.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); go(); } });
      return {
        nodes: head('What should we call you?', 'So your protocol and our WhatsApp team know who you are. Optional.').concat(field),
        foot: [primaryBtn('Build my protocol', go), h('button', { type: 'button', class: 'bx-link', text: 'Skip', onclick: function () { a.name = ''; advance('name'); } })],
        focus: field
      };
    },
    building: function (a) {
      /* The shopper watches their own answers being read, then the match. The product is revealed next, before any price. */
      var goal = GOAL[a.goal];
      var opt = goal.options[a.refine] || goal.options[0];
      var sex = (SEXES.filter(function (x) { return x.key === a.sex; })[0] || {}).label;
      var exp = (EXPERIENCE.filter(function (x) { return x.key === a.experience; })[0] || {}).label;
      var items = [
        ['Your goal', goal.label + ' \u00B7 ' + opt.label],
        ['About you', a.sex === 'na' ? a.age : a.age + ' \u00B7 ' + sex],
        ['Your experience', exp],
        ['Matching you to the BioLux range', null],
        ['Your protocol is ready', null]
      ].map(function (t) {
        return h('li', { class: 'bx-build__item' }, h('span', { class: 'bx-build__dot', svg: svg(ICON.check, 14) }),
          h('span', { class: 'bx-build__text' }, h('strong', { text: t[0] }), t[1] ? h('span', { text: t[1] }) : null));
      });
      var listEl = h('ul', { class: 'bx-build__list' });
      items.forEach(function (li) { listEl.appendChild(li); });
      var meter = h('div', { class: 'bx-build__meter', 'aria-hidden': 'true' }, h('span', { style: 'animation-duration:' + BUILD_MS + 'ms' }));
      var wrap = h('div', { class: 'bx-build', role: 'status' });
      head((a.name ? a.name + ', building' : 'Building') + ' your protocol', 'From what you told us.').forEach(function (n) { if (n) wrap.appendChild(n); });
      wrap.appendChild(meter);
      wrap.appendChild(listEl);
      var beat = (BUILD_MS - 700) / items.length;
      items.forEach(function (li, i) { setTimeout(function () { li.classList.add('is-done'); }, 380 + i * beat); });
      ensureOffer();
      clearTimeout(buildTimer);
      buildTimer = setTimeout(function () {
        if (!flowSheet.open || state.step !== 'building') return;
        var rec = recommend(a);
        if (!rec) { location.assign(GOAL[a.goal] ? GOAL[a.goal].collection : R.root); return; }
        write('localStorage', 'bx:protocol', { answers: a, at: Date.now() });
        track('protocol_finder_result', { concern: a.goal, product: rec.handle });
        push('result');
        render('result', 'forward');
      }, BUILD_MS);
      return { nodes: [wrap], bare: true };
    },
    result: function (a) {
      var rec = recommend(a);
      var offer = offerNow();
      /* The code can land a moment after the result does. Show the result now and add the offer when it arrives. */
      if (!offer) ensureOffer().then(function (got) { if (got && flowSheet.open && state.step === 'result') render('result', 'none'); });
      refreshSaved();
      var addon = rec.addon;
      if (!addon) addonOn = false;
      /* Three groups: the protocol, the choices that set the price, and what follows. Phones stack them. Wide screens keep the choices beside the rest. */
      var intro = head(rec.product.title, null, a.name ? a.name + ', your protocol' : 'Your protocol');
      var buy = [];
      var after = [];
      var canChoose = !!(rec.packs.single && rec.packs.full);
      intro.push(h('div', { class: 'bx-result__tags' },
        h('span', { class: 'bx-tag', text: 'For ' + rec.goal.short }),
        canChoose ? null : h('span', { class: 'bx-tag', text: rec.variant.title.replace(/\s+/g, ' ') })));
      if (rec.product.img) intro.push(h('a', { class: 'bx-result__hero', href: rec.product.url, 'aria-label': 'View ' + rec.product.title }, h('img', { src: rec.product.img, alt: rec.product.title, width: 720, height: 720 })));

      var why = h('ul', { class: 'bx-why' });
      function reason(title, text) { why.appendChild(h('li', {}, h('span', { svg: svg(ICON.check, 18) }), h('span', {}, h('strong', { text: title }), text))); }
      reason(rec.opt.label, rec.opt.why);
      if (a.experience === 'pen') reason('You already have a BioLux pen', 'So you only need a cartridge refill.');
      else reason(a.experience === 'new' ? 'You are new to peptides' : 'You have used peptides before', canChoose ? 'So you start with a full pack, which includes the pen.' : 'So we chose the ' + packName(rec.variant) + '.');
      intro.push(h('h3', { class: 'bx-result__h', text: 'Why this fits you' }), why);

      var priceNow = h('span', { class: 'bx-price__now' });
      var priceWas = h('span', { class: 'bx-price__was' });
      var checkoutBtn = h('button', { type: 'button', class: 'bx-btn bx-btn--ink bx-btn--block' });
      var waBtn = h('a', { class: 'bx-btn bx-btn--wa bx-btn--block', target: '_blank', rel: 'noopener', 'aria-label': 'Order on WhatsApp' }, h('span', { svg: WA_ICON }), 'WhatsApp');
      var error = h('p', { class: 'bx-error', role: 'alert', hidden: true });
      function total() { return rec.variant.price + (addonOn && addon ? addon.variant.price : 0); }
      function paint() {
        var full = total();
        var now = offer ? Math.round(full * (1 - offer.percent / 100)) : full;
        priceNow.textContent = money(now);
        priceWas.textContent = offer ? money(full) : '';
        priceWas.hidden = !offer;
        checkoutBtn.textContent = 'Checkout · ' + money(now);
        waBtn.href = 'https://wa.me/' + DATA.wa + '?text=' + encodeURIComponent(waMessage(a, rec, addonOn && addon, offer));
      }

      if (offer) {
        var codeBtn = h('button', { type: 'button', class: 'bx-offer__code', 'aria-label': 'Copy code ' + offer.code }, h('span', { text: offer.code }), h('span', { class: 'bx-offer__copy', text: 'Copy' }));
        codeBtn.addEventListener('click', function () {
          var label = $('.bx-offer__copy', codeBtn);
          var done = function () { label.textContent = 'Copied'; setTimeout(function () { label.textContent = 'Copy'; }, 1600); };
          if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(offer.code).then(done, function () {});
        });
        buy.push(h('div', { class: 'bx-offer' },
          h('div', { class: 'bx-offer__top' },
            h('div', {}, h('h3', { class: 'bx-offer__title', text: offer.partner ? offer.percent + '% off with ' + offer.partner.split(' ')[0] : offer.percent + '% off your protocol' }), h('p', { class: 'bx-offer__sub', text: offer.left === null ? 'For your first protocol. Applied at checkout, or quote it on WhatsApp.' : 'Your own code, valid until the timer ends. Applied at checkout, or quote it on WhatsApp.' })),
            offer.left === null ? null : h('span', { class: 'bx-offer__time', 'data-bx-countdown': '', 'aria-label': 'Time left', text: clock(offer.left) })),
          codeBtn));
      }

      if (canChoose) {
        var packGroup = h('div', { class: 'bx-opts bx-opts--packs', role: 'group', 'aria-label': 'Pack size' });
        /* A double pack is one pen with two cartridges: compare it with a starter pack plus one refill. Two refills compare with a refill x2. */
        var refill = pickVariant(rec.product, 'refill');
        var saving = a.experience === 'pen' ? rec.packs.single.price * 2 - rec.packs.full.price : (refill ? rec.packs.single.price + refill.price - rec.packs.full.price : 0);
        var cut = function (cents) { return offer ? Math.round(cents * (1 - offer.percent / 100)) : cents; };
        [
          { key: 'single', v: rec.packs.single, sub: rec.packs.single.inc || null },
          { key: 'full', v: rec.packs.full, sub: rec.packs.full.inc || null, tag: saving > 0 ? 'Save ' + money(saving) : null }
        ].forEach(function (x) {
          packGroup.appendChild(option({ label: packName(x.v), sub: x.sub, tag: x.tag, price: money(cut(x.v.price)), was: offer ? money(x.v.price) : null, on: rec.variant === x.v, onPick: function (el) {
            a.plan = x.key;
            keep();
            write('localStorage', 'bx:protocol', { answers: a, at: Date.now() });
            rec = recommend(a);
            $$('.bx-opt', packGroup).forEach(function (b) { b.setAttribute('aria-pressed', b === el ? 'true' : 'false'); });
            paint();
          } }));
        });
        buy.push(h('h3', { class: 'bx-result__h', text: 'Choose your pack' }), packGroup);
      }

      if (addon) {
        var addBtn = h('button', { type: 'button', class: 'bx-addon', 'aria-pressed': addonOn ? 'true' : 'false' },
          addon.product.img ? h('img', { src: addon.product.img, alt: '', width: 56, height: 56 }) : null,
          h('span', { class: 'bx-opt__text' }, h('span', { class: 'bx-opt__label', text: 'Add ' + addon.product.title }), h('span', { class: 'bx-opt__sub', text: 'For ' + addon.goal.short + ' · ' + money(addon.variant.price) })),
          h('span', { class: 'bx-opt__mark', svg: svg(ICON.check, 14) }));
        addBtn.addEventListener('click', function () { addonOn = !addonOn; addBtn.setAttribute('aria-pressed', addonOn ? 'true' : 'false'); paint(); });
        buy.push(h('h3', { class: 'bx-result__h', text: 'You also mentioned ' + addon.goal.short }), addBtn);
      }

      buy.push(h('div', { class: 'bx-price' }, h('span', { text: offer ? 'Your price today' : 'Your price' }), h('span', {}, priceWas, priceNow)));

      var next = h('ol', { class: 'bx-next' });
      [['A short eligibility check', 'Three quick questions in your cart.'], ['A registered doctor reviews your order', 'Before anything ships.'], ['Delivered cold chain to your door', 'With our team on WhatsApp if you need us.']].forEach(function (s) {
        next.appendChild(h('li', {}, h('span', {}, h('strong', { text: s[0] }), s[1])));
      });
      after.push(h('h3', { class: 'bx-result__h', text: 'What happens next' }), next);

      var also = h('p', { class: 'bx-result__also' });
      if (rec.alt) { also.appendChild(document.createTextNode('Also worth considering: ')); also.appendChild(h('a', { href: P[rec.alt].url, text: P[rec.alt].title })); also.appendChild(document.createTextNode('. ')); }
      if (a.sex === 'female' && a.goal !== 'menopause' && /^(40|50|60)/.test(a.age || '')) { also.appendChild(document.createTextNode('Many women your age also look at our ')); also.appendChild(h('a', { href: GOAL.menopause.collection, text: 'menopause support range' })); also.appendChild(document.createTextNode('.')); }
      if (also.childNodes.length) after.push(also);
      if (DATA.note) after.push(h('p', { class: 'bx-note', text: DATA.note }));
      after.push(h('button', { type: 'button', class: 'bx-link', text: 'Start again', onclick: function () {
        state.answers = {}; keep(); addonOn = false;
        try { history.replaceState({ bx: 'goal', i: depth }, ''); } catch (e) {}
        render('goal', 'back');
      } }));

      checkoutBtn.addEventListener('click', function () { checkout(a, rec, addonOn && addon, offer, checkoutBtn, error, paint); });
      waBtn.addEventListener('click', function () { track('protocol_finder_whatsapp', { concern: a.goal, product: rec.handle }); });
      paint();
      if (offer && offer.left !== null) setTimeout(startTicker, 0);
      var group = function (name, list) { var el = h('div', { class: 'bx-result__' + name }); list.forEach(function (n) { if (n) el.appendChild(n); }); return el; };
      return { nodes: [group('intro', intro), group('buy', buy), group('after', after)], foot: [error, h('div', { class: 'bx-cta-row' }, checkoutBtn, waBtn)], raised: true, done: true, wide: true };
    }
  };

  function summary(a, rec, addon) {
    var parts = ['Goal: ' + rec.goal.label, 'Detail: ' + rec.opt.label];
    if (a.also && a.also.length) parts.push('Also: ' + a.also.map(function (k) { return GOAL[k] ? GOAL[k].label : k; }).join(', '));
    parts.push('Age: ' + a.age, 'Sex: ' + (a.sex === 'na' ? 'not given' : a.sex), 'Experience: ' + a.experience);
    parts.push('Suggested: ' + rec.product.title + ' (' + rec.variant.title.replace(/\s+/g, ' ') + ')' + (addon ? ' + ' + addon.product.title : ''));
    return parts.join(' | ');
  }
  function waMessage(a, rec, addon, offer) {
    var msg = 'Hi BioLux!' + (a.name ? ' I am ' + a.name + '.' : '') + ' My protocol finder result is ' + rec.product.title + ' (' + rec.variant.title.replace(/\s+/g, ' ') + ') for ' + rec.goal.short + '.';
    if (addon) msg += ' I would also like to add ' + addon.product.title + '.';
    if (offer) msg += ' My code is ' + offer.code + ' for ' + offer.percent + '% off.';
    return msg + ' I would like to order. ' + location.origin + rec.product.url;
  }
  function post(url, payload) {
    return fetch(url + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
  }
  /* Adds only what the cart does not already hold, so a second tap or a return visit never doubles the order. */
  function checkout(a, rec, addon, offer, btn, error, repaint) {
    if (busy) return;
    busy = true;
    error.hidden = true;
    btn.setAttribute('aria-disabled', 'true');
    btn.textContent = 'Adding to your cart';
    var want = [rec.variant.id].concat(addon ? [addon.variant.id] : []);
    fetch(R.cart + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (cart) {
        var have = (cart.items || []).map(function (i) { return i.variant_id; });
        var items = want.filter(function (id) { return have.indexOf(id) === -1; }).map(function (id) { return { id: id, quantity: 1 }; });
        if (!items.length) return null;
        return post(R.cartAdd, { items: items }).then(function (r) { if (!r.ok) throw new Error('add'); });
      })
      .then(function () {
        /* Context for the reviewing doctor and the sales team. Losing it must not block the order. */
        return post(R.cartUpdate, { attributes: { 'Protocol finder': summary(a, rec, addon) } }).catch(function () {});
      })
      .then(function () {
        track('protocol_finder_checkout', { concern: a.goal, product: rec.handle, offer: offer ? offer.code : '' });
        var live = offerNow();
        location.assign(live ? R.root.replace(/\/$/, '') + '/discount/' + encodeURIComponent(live.code) + '?redirect=' + encodeURIComponent(R.cart) : R.cart);
      })
      .catch(function () {
        busy = false;
        btn.removeAttribute('aria-disabled');
        repaint();
        error.textContent = 'We could not add that to your cart. ';
        error.appendChild(h('a', { href: rec.product.url, text: 'Open the product page' }));
        error.appendChild(document.createTextNode(' or order on WhatsApp.'));
        error.hidden = false;
      });
  }

  function render(step, dir) {
    if (!canShow(step)) step = 'goal';
    state.step = step;
    var view = VIEW[step](state.answers);
    var done = step === 'result';
    var at = done || step === 'building' ? STEPS.length : STEPS.indexOf(step);
    var ratio = Math.max(0.04, at / STEPS.length);
    bar.style.transform = 'scaleX(' + ratio + ')';
    progress.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
    progress.style.visibility = done || step === 'building' ? 'hidden' : ''; /* the build has its own meter */
    backBtn.hidden = step === 'goal' || step === 'building';

    flowSheet.setAttribute('data-view', step); /* the result is wider than a question on wide screens */
    var page = h('div', { class: 'bx-step' + (view.wide ? ' bx-step--wide' : '') + (dir === 'none' ? '' : ' bx-enter'), 'data-dir': dir });
    view.nodes.forEach(function (n) { if (n) page.appendChild(n); });
    body.textContent = '';
    body.appendChild(page);
    body.scrollTop = 0;
    foot.textContent = '';
    foot.className = 'bx-flow__foot' + (view.raised ? ' bx-flow__foot--raised' : '');
    (view.foot || []).forEach(function (n) { if (n) foot.appendChild(n); });
    /* Move focus with the page so keyboards and screen readers follow; never steal the keyboard on phones. */
    var target = view.focus && window.matchMedia('(hover: hover) and (pointer: fine)').matches ? view.focus : $('.bx-step__title', page);
    if (target && dir !== 'none') { try { target.focus({ preventScroll: true }); } catch (e) {} }
  }
  /* Opened part-way in (a goal card, a saved result): there is no history to pop, so step back in place. */
  backBtn.addEventListener('click', function () {
    if (depth > 1) { history.back(); return; }
    var i = state.step === 'result' ? STEPS.length : STEPS.indexOf(state.step);
    var prev = STEPS[i - 1];
    try { history.replaceState({ bx: prev, i: depth }, ''); } catch (e) {}
    render(prev, 'back');
  });

  /* ---------- openers anywhere on the page ---------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-bx-open]');
    if (!opener) return;
    e.preventDefault();
    if (unwinding) return;
    if (opener.getAttribute('data-bx-open') === 'search') { openSearch(); return; }
    var goal = opener.getAttribute('data-bx-goal');
    if (goal && GOAL[goal]) { state.answers = { goal: goal }; openFlow('refine'); return; }
    openFlow(GOAL[state.answers.goal] ? firstOpen() : 'goal');
  });
  /* Resume where the visitor left off rather than making them repeat answers. */
  function firstOpen() {
    for (var i = 0; i < STEPS.length; i++) {
      var s = STEPS[i];
      var a = state.answers;
      var answered = s === 'goal' ? !!GOAL[a.goal] : s === 'refine' ? a.refine != null : s === 'also' ? !!a.alsoSeen : s === 'about' ? !!(a.age && a.sex) : s === 'experience' ? !!a.experience : a.name != null;
      if (!answered) return s;
    }
    return canShow('result') ? 'result' : 'goal';
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector('[data-bx-protocol]')) location.reload(); });
  }

  /* ---------- start-up: saved protocol chip, deep links, return visits ---------- */
  refreshSaved();
  var params = new URLSearchParams(location.search);
  var linked = params.get('protocol');
  if (linked != null || location.hash === '#protocol') {
    if (GOAL[linked]) { state.answers = { goal: linked }; openFlow('refine'); } else openFlow('goal');
  } else if (history.state && history.state.bx && history.state.bx !== 'search' && canShow(history.state.bx)) {
    /* Back from a product page or the cart: put the visitor back on the step they left. */
    depth = history.state.i || 1;
    showSheet(flowSheet);
    render(history.state.bx === 'building' ? 'result' : history.state.bx, 'none');
  }
})();
